export default {
    setAllUnits(state, units) {
        state.allUnits = units;
    },
};
